import { render } from "./SportsBar.vue?vue&type=template&id=4bdb7ace&scoped=true"
import script from "./SportsBar.vue?vue&type=script&lang=js"
export * from "./SportsBar.vue?vue&type=script&lang=js"

import "./SportsBar.vue?vue&type=style&index=0&id=4bdb7ace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdb7ace"]])

export default __exports__